import { transparentize } from 'polished';
import styled from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';

interface WrapperProps {
  $color: string;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;

  gap: 6px;

  padding: 5px 9px;
  margin-top: 2px;

  border-radius: 40px;

  border-width: 1px;
  border-style: solid;

  color: ${({ $color }) => $color};
  border-color: ${({ $color }) => transparentize(0.5, $color)};
  background: ${({ $color }) => transparentize(0.9, $color)};
`;

interface TextProps {
  color: string;
}

export const Text = styled.span<TextProps>`
${TYPOGRAPHY.CIRCULAR.bold}
  font-size: 12px;
  line-height: normal;
  color: ${({ color }) => color};
`;
